import styled, { css } from 'styled-components';
import { Label } from '../../../Components/uielements';
import { key, palette } from 'styled-theme';
import { media } from '../../../helper/styleHelper';

export const DashboardContainer = styled.div`
  display: grid;
  gap: ${key('sizes.gap.big', '40px')};
`;

export const DashboardHeaderContainer = styled.div`
  display: grid;
  justify-content: center;
`;
export const OwnerDashboardHeaderContainer = styled.div`
  display: grid;
  justify-content: center;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const ButtonWrapper = styled.div`
  display: grid;
  justify-content: center;
  grid-auto-flow: column;
  gap: 20px;
`;

export const DashboardHeaderTitle = styled(Label)`
  font-family: Space Grotesk Bold;
  font-size: ${key('sizes.vxxlFont.header2', '24px')} !important;
  font-weight: bold;
  color: ${palette('text', 4)};
`;

export const DashboardCardContainer = styled.div`
  display: grid;
  border: 1px solid ${palette('border', 1)};
  border-radius: ${key('sizes.borderRadius.normal', 4)};
  padding: 30px;
  gap: 20px;
`;

export const DashboardContainerLeft = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${key('sizes.gap.normal', '25px')};

  ${media.xl`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const DashboardContainerRight = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  gap: 10px;
`;

export const DashboardContainerRightTitle = styled(Label)`
  color: ${palette('text', 4)} !important;
`;

export const DashboardCard = styled.div`
  ${media.xl`
     min-height: 300px;
  `}
  ${(props) =>
    props.image &&
    css`
      background: url(${props.image}) center center no-repeat;
    `}
  background-size: cover;
  position: relative;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
`;

export const LogoTitle = styled(Label).attrs({ color: 'dark' })`
  font-size: 10px !important;
  position: absolute;
  top: 0;
  left: 0;
  padding: 5px;
  background-color: ${palette('background', 2)};
`;

export const CardCount = styled(Label)`
  align-self: center;
  justify-self: center;
  font-size: 90px !important;
`;

export const DashboardTableContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${key('sizes.gap.normal', '20px')};
  border: 1px solid ${palette('border', 1)};
  border-radius: ${key('sizes.borderRadius.normal', 4)};
  padding: 30px;
  margin-bottom: 10px;

  ${media.xl`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const DashboardTableContent = styled.div`
  display: grid;
  height: fit-content;
  gap: 24px;
`;

export const DashboardTableView = styled.div`
  display: grid;
  gap: ${key('sizes.gap.small', '10px')};
  border: 1px solid ${palette('border', 1)};
  border-radius: ${key('sizes.borderRadius.normal', 4)};
  padding: 20px 30px 30px 30px;
`;

export const DashboardCountView = styled.div`
  display: grid;
  gap: ${key('sizes.gap.small', '10px')};
  border: 1px solid ${palette('border', 1)};
  border-radius: ${key('sizes.borderRadius.normal', 4)};
  padding: 20px 30px 60px 30px;
`;

export const DashboardCountContainer = styled.div`
  display: grid;
  gap: 64px;
  padding-top: 30px;
`;

export const DashboardCountContainerRight = styled.div`
  display: grid;
  gap: ${key('sizes.gap.small', '10px')};
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
  text-align: center;
`;

export const DashboardCountContainerLeft = styled.div`
  display: grid;
  gap: ${key('sizes.gap.small', '10px')};
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
  text-align: center;
`;

export const DashboardCountCard = styled.div`
  display: grid;
  grid-auto-flow: row;
  position: relative;
  cursor: pointer;
  gap: 8px;
`;

export const DashboardCountCardLeft = styled.div``;

export const DashboardCountCardRight = styled.div`
  color: ${palette('text', 1)};
  text-transform: uppercase;
`;

export const CountTitle = styled(Label)`
  font-family: Space Grotesk Regular;
  font-size: ${key('sizes.vxxlFont.normal', '20px')} !important;
  color: ${palette('text', 1)};
  cursor: pointer;
`;

export const CompanyTitle = styled(Label)`
  font-family: Space Grotesk Regular;
  font-size: 40px !important;
  color: ${palette('text', 1)};
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LabelCount = styled(Label)`
  color: ${palette('text', 4)};
  cursor: pointer;
  font-size: 36px;
  font-style: normal;
  font-weight: 300;
  line-height: 110%;
  letter-spacing: 0.72px;
  text-transform: uppercase;
`;

export const TableCell = styled(Label)``;

export const LinksWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  column-gap: 40px;
  justify-content: center;
  align-items: center;
  height: 100%;

  ${media.xl`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
`;
export const LogoWrapper = styled.div`
  display: inline-block; /* Ensures the container only takes up the necessary space */
  cursor: pointer;
`;

export const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  padding-bottom: 5px;
`;

export const LinksContainerWithDelete = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  cursor: pointer;
  padding-bottom: 5px;
`;

export const LinksLabel = styled(Label).attrs({ color: 'normal', cursor: 'pointer' })`
  text-decoration: underline;
  text-underline-offset: 3px;
  display: flex;
  gap: 20px;
`;

export const LinksModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 400px;
  max-height: 600px;
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: -webkit-fill-available;
`;

export const AddLinkContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 50px;
`;
export const ContentWrapper = styled.div`
  margin: auto;
  padding: 30px 20px;
  min-width: 400px;
  display: grid;
  gap: 10px;
  display: grid;
  place-items: center;
`;

// card css

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;

  ${media.xl`
    grid-template-columns: repeat(2, 1fr);
  `}
`;
export const CardContent = styled.div`
  border-bottom: 1px solid ${palette('border', 1)};
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  padding-bottom: 10px;
`;

export const CardTextBig = styled(Label)`
  color: #f9fffd;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  text-transform: capitalize;
`;
export const CardTextLight = styled(Label)`
  color: #a3a5b8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-transform: uppercase;
`;
export const CardTextBottom = styled(Label)`
  color: #f9fffd;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-transform: uppercase;
  > span {
    color: ${palette('active', 0)};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    text-transform: uppercase;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: calc(300 / 645 * 100%); /* Aspect ratio (height / width * 100%) */
  background-color: #f0f0f0; /* Optional: A fallback background color */
  overflow: hidden;
`;

export const Image = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: contain; /* Ensures the image fits without cropping */
`;

export const EditButton = styled.button`
  position: absolute;
  top: 0px;
  right: 0px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 10px;
  background-color: ${palette('background', 2)};
  z-index: 100;
`;

export const FileInput = styled.input`
  display: none;
`;
export const LoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
`;
// export const SwitchButtonWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
// `;
export const Tag = styled(Label).attrs({ color: 'dark' })`
  font-size: 11px !important;
  padding: 5px;
  background-color: ${palette('background', 2)};
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 5px;
`;

export const SwitchButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }
`;

export const Tooltip = styled.span`
  position: absolute;
  bottom: 120%;
  left: 30%;
  transform: translateX(-50%);
  background-color: #0f1126;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;
  border: 0.5px solid #7aeaa7;
`;
